/**
 * CSV-Export der Bestellung (Modul 38 / A12) — rein im Browser, ohne Backend.
 *
 * Aufbau, Trennzeichen, Quoting, CRLF, Download UND die Formel-Neutralisierung kommen aus
 * dem Hausbaustein `@/lib/csv` (Komma, RFC 4180, kein BOM). Die Neutralisierung lag
 * zwischenzeitlich hier, weil dieses Fenster nur `pages/purchase/**` beanspruchte; seit dem
 * Koordinator-Auftrag vom 17.08. 21:00 steht sie im Baustein und schuetzt damit auch
 * Reichweite, Uebersicht und Artikel-Analyse.
 *
 * Eigen bleibt genau eine Regel: PREISE NUR MIT BERECHTIGUNG. Ohne
 * `article_purchase_prices` faellt die Preisspalte KOMPLETT weg — nicht „leer". Eine leere
 * Spalte „PI-Preis" waere die Aussage „es gibt keinen Preis"; richtig ist „du darfst ihn
 * nicht sehen" (Design §7.1, Codex-Befund 27).
 */
import { buildCsv, downloadCsv } from "@/lib/csv";

/**
 * Wandelt einen Wert in eine Zelle.
 *
 * Die Formel-Neutralisierung liegt seit dem 17.08. im Hausbaustein `@/lib/csv` und wirkt
 * damit fuer ALLE Exporte (Koordinator-Auftrag 21:00) — hier bleibt nur die Umwandlung.
 * Wichtig dabei: `null` wird zur LEEREN Zelle, nicht zum Wort „null"; ein solches Wort
 * liest der Einkauf im Tabellenprogramm als Wert.
 */
export function csvZelle(wert: string | number | null | undefined): string {
  if (wert === null || wert === undefined) return "";
  return String(wert);
}

export interface CsvPosition {
  merchant_sku: string | null;
  /** Lagernummer aus stock_items.sku — seit dem Vertrag 680f5edb im Positions-Typ. */
  sku: string | null;
  name_snapshot: string | null;
  qty: number;
  unit_price_usd: number | null;
  anforderungs_notiz: string | null;
}

/**
 * Baut die CSV einer Bestellung.
 *
 * Die Spalte „Lagernummer" kam mit dem Vertrag 680f5edb dazu (`sku`, per Join aus
 * `stock_items` — keine neue Spalte auf den Positionen). Vorher fehlte sie bewusst: eine
 * Spalte, die in JEDER Zeile leer ist, behauptet eine fehlende Angabe statt einer fehlenden
 * Quelle.
 */
export function bestellungAlsCsv(positionen: CsvPosition[], mitPreisen: boolean): string {
  const kopf = ["Sternnummer", "Lagernummer", "Artikel", "Menge", ...(mitPreisen ? ["PI-Preis (USD)"] : []), "Anforderung"];
  const zeilen = positionen.map((p) => [
    csvZelle(p.merchant_sku),
    csvZelle(p.sku),
    csvZelle(p.name_snapshot),
    csvZelle(p.qty),
    ...(mitPreisen ? [csvZelle(p.unit_price_usd)] : []),
    csvZelle(p.anforderungs_notiz),
  ]);
  return buildCsv(kopf, zeilen);
}

/** Dateiname aus der Bestellnummer — ohne Zeichen, die Dateisysteme nicht moegen. */
export function csvDateiname(bestellNummer: string): string {
  return `bestellung-${bestellNummer.replace(/[^A-Za-z0-9._-]/g, "_")}.csv`;
}

export { downloadCsv as csvHerunterladen };
